import { useSyncExternalStore } from 'react';

/**
 * حالةُ الخدمة كما يراها المستخدم (27 سبتمبر 2026): طلبان متتاليان سقطا بـ5xx (أو بلا شبكة) = عطلٌ
 * مؤقت، فيظهر شريطٌ واحدٌ لطيف بدل رسائل متفرّقة تحت كل زرّ. وأولُ طلبٍ ينجح بعده يُخفيه وحده.
 * والشريطُ يقول «لم يُحفظ آخرُ إجراء» **فقط** إن كان آخرُ ما سقط كتابةً — القراءةُ الساقطة لا تُفقد شيئاً.
 */
export interface ServiceHealth { failures: number; lastWriteFailed: boolean; dismissed: boolean }
export const OUTAGE_AFTER = 2;

let state: ServiceHealth = { failures: 0, lastWriteFailed: false, dismissed: false };
const subs = new Set<() => void>();
const set = (next: ServiceHealth) => { if (next.failures !== state.failures || next.lastWriteFailed !== state.lastWriteFailed || next.dismissed !== state.dismissed) { state = next; for (const s of subs) s(); } };

/** تُنادى بعد كل ردٍّ من الخادم — `status` صفرٌ حين لم يصل الطلبُ أصلاً */
export function noteResponse(status: number, method: string) {
  if (status === 0 || status >= 500) {
    set({ failures: state.failures + 1, lastWriteFailed: method !== 'GET', dismissed: state.dismissed });
  } else if (state.failures > 0) {
    set({ failures: 0, lastWriteFailed: false, dismissed: false });
  }
}
export function dismissOutage() { set({ ...state, dismissed: true }); }
export function outageVisible(s: ServiceHealth) { return s.failures >= OUTAGE_AFTER && !s.dismissed; }
/** لقطةٌ بلا React — للفحص */
export function serviceHealth(): ServiceHealth { return state; }
export function resetServiceHealth() { set({ failures: 0, lastWriteFailed: false, dismissed: false }); }

export function useServiceHealth(): ServiceHealth {
  return useSyncExternalStore((cb) => { subs.add(cb); return () => { subs.delete(cb); }; }, () => state, () => state);
}
